import React from 'react';
import RouteLayout from './RouteLayouts';
import { BrowserRouter as Router } from 'react-router-dom';
import asyncComponent from './AsyncComponent';

// Crear chunks para no descargar todas las páginas completas
const AsyncScheduledPage   = asyncComponent(() => import("../views/ScheduledPage"));
const AsyncLoginPage       = asyncComponent(() => import("../views/LoginPage"));
const AsyncLogoutPage      = asyncComponent(() => import("../views/LogoutPage"));
const AsyncStationsPage    = asyncComponent(() => import("../views/stations/StationPage"));
const AsyncStationsNewPage = asyncComponent(() => import("../views/stations/StationNewPage"));
const AsyncDevicesPage     = asyncComponent(() => import("../views/devices/DevicePage"));
const AsyncDeviceEditPage  = asyncComponent(() => import("../views/devices/DeviceEditPage"));
const AsyncDeviceChannelsPage = asyncComponent(() => import("../views/devices/DeviceChannelsPage"));
const AsyncDeviceInternetRadiosPage = asyncComponent(() => import("../views/devices/DeviceInternetRadiosPage"));
const AsyncAudioPage       = asyncComponent(() => import("../views/AudioPage"));
const AsyncWebCampaignPage = asyncComponent(() => import("../views/web-campaign/WebCampaignPage"));
const AsyncWebAdsPage      = asyncComponent(() => import("../views/web-campaign/WebAdsPage"));
const AsyncWebAdEditPage   = asyncComponent(() => import("../views/web-campaign/WebAdEditPage"));
const AsyncWebHistoryPage  = asyncComponent(() => import("../views/web-campaign/WebHistoryPage"));
const AsyncMonitorPage     = asyncComponent(() => import("../views/MonitorPage"));
const AsyncAvisoPage       = asyncComponent(() => import("../views/AvisoPage"));

const Routes = () => (
  <Router>
    <div>
      <RouteLayout path="/" exact={true} requireAuth={true} component={AsyncScheduledPage} />
      <RouteLayout path="/login" component={AsyncLoginPage} />
      <RouteLayout path="/logout" requireAuth={true} component={AsyncLogoutPage} />
      <RouteLayout path="/stations" exact={true} requireAuth={true} component={AsyncStationsPage} />
      <RouteLayout path="/stations/new" exact={true} requireAuth={true} component={AsyncStationsNewPage} />
      <RouteLayout path="/devices" exact={true} requireAuth={true} component={AsyncDevicesPage} />
      <RouteLayout path="/devices/:id/edit" requireAuth={true} component={AsyncDeviceEditPage} />
      <RouteLayout path="/devices/:id/channels" requireAuth={true} component={AsyncDeviceChannelsPage} />
      <RouteLayout path="/devices/:id/internet-radios" requireAuth={true} component={AsyncDeviceInternetRadiosPage} />
      <RouteLayout path="/audio" requireAuth={true} component={AsyncAudioPage} />
      <RouteLayout path="/web-campaign/:cid/ad/:id/history" exact={true} requireAuth={true} component={AsyncWebHistoryPage} />
      <RouteLayout path="/web-campaign/:cid/ad/:id" exact={true} requireAuth={true} component={AsyncWebAdEditPage} />
      <RouteLayout path="/web-campaign/:id" exact={true} requireAuth={true} component={AsyncWebAdsPage} />
      <RouteLayout path="/web-campaign" exact={true} requireAuth={true} component={AsyncWebCampaignPage} />
      <RouteLayout path="/monitor" exact={true} requireAuth={true} component={AsyncMonitorPage} />
      <RouteLayout path="/aviso" exact={true} requireAuth={false} component={AsyncAvisoPage} />
    </div>
  </Router>
);

export default Routes;


// WEBPACK FOOTER //
// ./src/components/Route.js